import React from "react";

export const Header = ({ data }) => {
  const d = data || {};
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>{d.title}<span></span></h1>
                <p>{d.paragraph}</p>
                <a href={d.cta_primary_href || "#contact"} className="btn btn-custom btn-lg page-scroll">
                  {d.cta_primary || "Book a Free Consultation"}
                </a>{" "}
                <a href={d.cta_secondary_href || "#features"} className="btn btn-default btn-lg page-scroll header-btn-secondary">
                  {d.cta_secondary || "See How It Works"}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
